// extracted by mini-css-extract-plugin
export default {"loading":"threadDetail_loading__gN4Sy","pcWrap":"threadDetail_pcWrap__lYhb0"};